// extracted by mini-css-extract-plugin
export default {"root":"eUrclm","seoDescription":"PMpd8j"};